import React from 'react';
import styled from 'styled-components';
// import ReferenceTable from '../../components/ReferenceTable';
import MainHeaderImage from '../../components/MainHeaderImage/MainHeaderImage';
import referenceImg from '../../assets/reference.png';

export default function ReferenceContent() {
  return (
    <PageWrapper>
      <HeaderBox>
        <h3>Společenství vlastníků jednotek</h3>
        <h3>Bytová družstva</h3>
        <h3>Společnosti s ručením omezeným</h3>
      </HeaderBox>
      <MainHeaderImage />
      <SignBox>
        <SignContainer>
          <h2>Již více než 12 let zkušeností jednatele v oblasti SVJ a BD</h2>
          <h2>3 roky historie zprostředkovatele financování ve výhradním zastoupení</h2>
        </SignContainer>
      </SignBox>
      <ImageContainer>
        <Image src={referenceImg} alt='reference' />
      </ImageContainer>
      {/* <ReferenceTable /> */}
      <TextBox>
        <h4>
          <i>
            V případě zájmu o kontakty na jednotlivé domy nás kontaktujte, budou Vám předány pouze po předchozím
            projednání se zástupci jednotlivých domů.
          </i>
        </h4>
      </TextBox>
    </PageWrapper>
  );
}

const Image = styled.img`
  width: 100%;
  height: 100%;
`;
const ImageContainer = styled.div`
  width: 100%;
`;
const SignContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  h2::after {
    width: 0 !important;
    height: 0 !important;
  }
  h2 {
    margin-bottom: 8px !important;
  }

  @media (max-width: 850px) {
    padding: 0 4%;

    h2 {
      text-align: center;
    }
  }
`;

const TextBox = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 2%;
  width: 100%;
  max-width: 1800px;
  margin: 0 auto;
`;

const SignBox = styled.div`
  width: 100%;
  max-width: 1800px;
  margin: 0 auto;
`;

const HeaderBox = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
  max-width: 1800px;
  margin: 0 auto;

  h3 {
    background: rgba(255, 0, 0, 0.6);
    padding: 6px 12px;
    box-shadow: 1px 12px 24px ${({ theme }) => theme.palette.black.light};
  }

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: center;
  }

  @media (max-width: 350px) {
    padding: 0 4%;
  }
`;

const PageWrapper = styled.div``;
